import TriggerNode from "./trigger";
import ConditionNode from "./condition";
import EmailActionNode from "./email-action";
import ReturnEmailActionNode from "./return-email-action";
import ReturnOrderNoteActionNode from "./return-order-note-action";
import ReturnOrderAttributeActionNode from "./return-order-attribute-action";
import ReturnAutoTreatActionNode from "./return-auto-treat-action";
import WebActionNode from "./tracking-page-action";
import WalletNotificationActionNode from "./wallet-notification-action";
import GorgiasActionNode from "./gorgias-action";
import ZendeskActionNode from "./zendesk-action";
import KlaviyoActionNode from "./klaviyo-action";
import BrevoActionNode from "./brevo-action";
import ModifyOrderTagsActionNode from "./modify-order-tags-action";
import WebhookActionNode from "./webhook-action";
import { EditorNodeType } from "./types";
import { RegisteredNode } from "../lib/register-node";

// Use a more flexible type for the registry to accept nodes with different data types
export const workflowNodesLibrary: Record<
  EditorNodeType,
  RegisteredNode<unknown> | null
> = {
  trigger: TriggerNode as RegisteredNode<unknown>,
  condition: ConditionNode as RegisteredNode<unknown>,
  "action:send_tracking_email": EmailActionNode as RegisteredNode<unknown>,
  "action:send_return_email": ReturnEmailActionNode as RegisteredNode<unknown>,
  "action:set_order_note": ReturnOrderNoteActionNode as RegisteredNode<unknown>,
  "action:set_order_attribute":
    ReturnOrderAttributeActionNode as RegisteredNode<unknown>,
  "action:auto_treat_return":
    ReturnAutoTreatActionNode as RegisteredNode<unknown>,
  "action:update_web": WebActionNode as RegisteredNode<unknown>,
  "action:send_wallet_notification":
    WalletNotificationActionNode as RegisteredNode<unknown>,
  "action:create_ticket_on_gorgias": GorgiasActionNode as RegisteredNode<unknown>,
  "action:create_ticket_on_zendesk": ZendeskActionNode as RegisteredNode<unknown>,
  "action:send_klaviyo_event": KlaviyoActionNode as RegisteredNode<unknown>,
  "action:send_brevo_event": BrevoActionNode as RegisteredNode<unknown>,
  "action:modify_order_tags": ModifyOrderTagsActionNode as RegisteredNode<unknown>,
  "action:send_webhook": WebhookActionNode as RegisteredNode<unknown>,
};

export function getWorkflowNodeConfig<T extends EditorNodeType>(
  type: T,
): RegisteredNode<unknown> | null {
  return workflowNodesLibrary[type];
}

export { NodeCategory } from "../lib/register-node";

export * from "./types";
export * from "./node-types";
export * from "./trigger";
export * from "./condition";
export * from "./email-action";
export * from "./return-email-action";
export * from "./return-order-note-action";
export * from "./return-order-attribute-action";
export * from "./return-auto-treat-action";
export * from "./tracking-page-action";
export * from "./wallet-notification-action";
export * from "./gorgias-action";
export * from "./zendesk-action";
export * from "./klaviyo-action";
export * from "./brevo-action";
export * from "./modify-order-tags-action";
export * from "./webhook-action";
